import React, { useState, useEffect } from "react";

function formatUSD(value) {
  if (!value) return "—";
  const v = Number(value);
  if (v >= 1e12) return `$${(v / 1e12).toFixed(2)}T`;
  if (v >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (v >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e3) return `$${(v / 1e3).toFixed(2)}K`;
  return `$${v.toFixed(0)}`;
}

export default function VolumeAnomalies({ rows }) {
  const [limit, setLimit] = useState(
    Number(localStorage.getItem("volumeRows")) || 10
  );

  useEffect(() => {
    localStorage.setItem("volumeRows", limit);
  }, [limit]);

  const visibleRows = rows.slice(0, limit);

  return (
    <section className="section">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "8px"
        }}
      >
        <h2 style={{ marginBottom: 0 }}>
          Highest Volume vs Market Cap Coins
        </h2>

        <select
          value={limit}
          onChange={(e) => setLimit(Number(e.target.value))}
          style={{
            background: "var(--bg-card)",
            color: "var(--text)",
            border: "1px solid var(--border)",
            borderRadius: "6px",
            padding: "4px 8px",
            fontSize: "13px",
            marginTop: "25px",
            cursor: "pointer"
          }}
        >
          <option value={5}>5 rows</option>
          <option value={10}>10 rows</option>
          <option value={15}>15 rows</option>
          <option value={25}>25 rows</option>
        </select>
      </div>

      {visibleRows.length === 0 ? (
        <p className="loading">
          ⏳ Gathering volume / market cap data — check back soon
        </p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Ticker</th>
              <th>Market Cap</th>
              <th>24h Volume</th>
              <th>Volume / Cap</th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((c) => {
              const volume = Number(c.volume24h ?? 0);
              const marketCap = Number(c.marketCap ?? 0);
              const ratio =
                marketCap > 0 ? volume / marketCap : null;

              return (
                <tr key={`${c.coin}-${c.symbol}`}>
                  <td>{c.symbol}</td>
                  <td>{formatUSD(c.marketCap)}</td>
                  <td>{formatUSD(c.volume24h)}</td>
                  <td>
                    {ratio === null ? "—" : `${ratio.toFixed(2)}×`}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
}
